// src/components/LoadingOverlay.tsx
import React from 'react';
import {
  Backdrop,
  CircularProgress,
  Typography,
  Box,
  Fade,
} from '@mui/material';

interface LoadingOverlayProps {
  open: boolean;
  message?: string;
  subMessage?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  open, 
  message = "Loading...", 
  subMessage 
}) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        backdropFilter: 'blur(4px)',
      }}
      open={open}
    >
      <Fade in={open} timeout={300}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          p={4}
        >
          <CircularProgress 
            size={60} 
            thickness={4}
            sx={{ 
              color: '#00C853',
              mb: 3,
              '& .MuiCircularProgress-circle': {
                strokeLinecap: 'round',
              }
            }} 
          />
          
          <Typography 
            variant="h6" 
            sx={{ 
              mb: 1,
              fontWeight: 600,
              color: 'white'
            }}
          >
            {message}
          </Typography>
          
          {subMessage && (
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.8)',
                maxWidth: 300
              }}
            >
              {subMessage}
            </Typography>
          )}
        </Box>
      </Fade>
    </Backdrop>
  );
};

export default LoadingOverlay;

